import getTheme from 'config/themes/base';

const theme = getTheme();

export default {
  gridContainer: {
    padding: '16px 0',
  },
  templateItem: {
    position: 'relative',
    cursor: 'pointer',
    borderRadius: '8px',
    overflow: 'hidden',
    border: `2px solid ${theme.palette.primary.borderColor || '#e0e0e0'}`,
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      borderColor: theme.palette.primary.main,
      transform: 'scale(1.02)',
      boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    },
    '&:focus': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: '2px',
    },
  },
  templateImage: {
    width: '100%',
    height: '150px',
    objectFit: 'cover',
    display: 'block',
  },
  templateLabel: {
    display: 'block',
    padding: '8px',
    textAlign: 'center',
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
  },
  emptyState: {
    padding: '40px',
    textAlign: 'center',
    width: '100%',
  },
  loadingState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '60px 20px',
    gap: '16px',
  },
  loadingText: {
    color: theme.palette.text.secondary,
    fontSize: '14px',
  },
};
